module.exports = [{"name":"Formal Lunch","id":"1","imgIcon":"img/icon_formal.svg"},{"name":"Work Lunch","id":"2","imgIcon":"img/icon_work.svg"}]


//////////////////
// WEBPACK FOOTER
// ./src/Data/Categories.json
// module id = INDk
// module chunks = 1